/** QuickRouter — Bibliothèque d'empreintes : recherche, catégories, pose d'un clic au centre
 *  de la carte. Les empreintes créées par l'assistant pour ce projet apparaissent en tête. */
import { useMemo, useState } from 'react';
import { useProjectStore } from '../store/useProjectStore.js';
import { searchFootprints } from '../../shared/library/index.js';

export default function LibraryPanel() {
  const library = useProjectStore((s) => s.library);
  const own = useProjectStore((s) => s.project.footprints);
  const place = useProjectStore((s) => s.placeFootprint);
  const readOnly = useProjectStore((s) => s.project.role === 'viewer');
  const [q, setQ] = useState('');
  const [cat, setCat] = useState('');
  const [custom, setCustom] = useState('');

  const all = useMemo(() => [...own, ...library.footprints.filter((f) => !own.some((o) => o.id === f.id))], [own, library.footprints]);
  const cats = useMemo(() => [...new Set(all.map((f) => f.category))], [all]);
  const list = searchFootprints(all, q, cat);

  return (
    <div className="panel-body">
      <input className="search" placeholder="Chercher : 0805, rs485, esp32, bornier…" value={q} onChange={(e) => setQ(e.target.value)} onKeyDown={(e) => e.stopPropagation()} />
      <div className="chips">
        <button className={!cat ? 'active' : ''} onClick={() => setCat('')}>Tout</button>
        {cats.map((c) => <button key={c} className={cat === c ? 'active' : ''} onClick={() => setCat(cat === c ? '' : c)}>{c}</button>)}
      </div>
      {list.map((f) => (
        <button key={f.id} className="lib-item" disabled={readOnly} title={f.description} onClick={() => place(f.id)}>
          <span className="lib-ico">{f.refPrefix}</span>
          <span className="grow">
            {f.name}
            <span className="lib-cat">{f.id} · {f.pads.length} pastille{f.pads.length > 1 ? 's' : ''}{f.defaults?.lcsc ? ` · ${f.defaults.lcsc}` : ''}{own.some((o) => o.id === f.id) ? ' · projet' : ''}</span>
          </span>
        </button>
      ))}
      {!list.length && <div className="empty">Aucune empreinte. Demandez à l'assistant de la créer d'après la fiche technique.</div>}
      <h3>Barrette au pas de 2,54</h3>
      <div className="row">
        <input className="grow" placeholder="pinheader-1x05, pinsocket-2x08…" value={custom} onChange={(e) => setCustom(e.target.value)} onKeyDown={(e) => { e.stopPropagation(); if (e.key === 'Enter' && custom) place(custom.trim()); }} />
        <button disabled={!custom || readOnly} onClick={() => place(custom.trim())}>Poser</button>
      </div>
    </div>
  );
}
